import { datadogRum } from '@datadog/browser-rum'

const isProd = process.env.NODE_ENV === 'production'

export function recordAction(name: string, attrs?: Record<string, unknown>): void {
  if (!isProd) return

  datadogRum.addAction(name, attrs)
}
